module.exports = __webpack_public_path__ + "static/img/verificated-shop-badge.afc8ae1b.svg";